module.exports = __webpack_public_path__ + "img/scene-creator.6dffae1c.svg";